"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const wrapper_component_1 = require("@/room/room_create/wrapper_component");
function default_1() {
    const title = (0, react_redux_1.useSelector)((state) => state.roomData.title);
    const dispatch = (0, react_redux_1.useDispatch)();
    const resetRoomTitle = () => dispatch((0, roomCreateStore_1.setRoomTitle)(''));
    const isCommission = (0, react_redux_1.useSelector)((state) => state.isCommission);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(wrapper_component_1.UpperSectionContentWrapper, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "required_wrapper subtitle2" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "gray-80" }, { children: t(isCommission ? '커미션 타입' : '작품 제목') })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "error-main" }, { children: "*" }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    height: '48px',
                    borderRadius: '8px',
                    border: '1px solid var(--gray-10)',
                    ':focus-within': { border: '1px solid var(--gray-60)' },
                } }, { children: [(0, jsx_runtime_1.jsx)("input", { className: "body2 gray-80", css: { width: '100%', height: '100%', padding: '0 14px', borderRadius: '8px' }, value: title, maxLength: 40, placeholder: t(isCommission ? '이름을 입력해 주세요. 예) A타입' : '제목을 입력해 주세요(예: 작품 이름)'), onBlur: e => {
                            const trimmed = e.target.value.trim();
                            if (!trimmed) {
                                dispatch((0, roomCreateStore_1.setRoomTitle)(''));
                            }
                        }, onChange: e => {
                            dispatch((0, roomCreateStore_1.setRoomTitle)(e.target.value));
                        }, onKeyDown: e => {
                            if (e.key === 'Escape') {
                                resetRoomTitle();
                            }
                        } }), Boolean(title === null || title === void 0 ? void 0 : title.length) && ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: { position: 'absolute', right: '12px' }, onClick: e => {
                            resetRoomTitle();
                            e.currentTarget.previousElementSibling.focus();
                        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: { width: '16px', height: '16px' } }) })))] }))] }));
}
exports.default = default_1;
